import { getField, updateField } from 'vuex-map-fields'
import { globalError } from '@/lib/utils'
import axios from '@/lib/axios'

export default {
  namespaced: true,
  state: {
    agencies: [],
    altEmail1: '',
    altEmail2: '',
    email: '',
    firstName: '',
    iceAgent: '',
    lastName: '',
    middleName: '',
    passExpDt: '',
    states: [],
    supervisorEmail: '',
    supervisorFirstName: '',
    supervisorLastName: '',
    supervisorMiddleName: '',
    supervisorPhone: '',
    supervisorRank: '',
    title: '',
    userLevel: '',
    username: '',
    workPhone: '',
  },
  getters: { getField },
  actions: {
    retrieveInfo({ state, commit }) {
      axios({ loaderDelay: 5000 })
        .get('/api/users/account_info')
        .then(resp => {
          let data = resp.data || {}
          Object.keys(data).forEach(el => {
            if (state[el] !== undefined) commit('update', [el, data[el]])
          })
        })
        .catch(err => {
          globalError(err)
        })
    },
    retrieveUserData({ state, commit }, { username }) {
      axios({ loaderDelay: 5000 })
        .get('/api/get_user_data', {
          params: {
            username: username,
          }
        })
        .then(resp => {
          let data = resp.data || {}
          Object.keys(data).forEach(el => {
            if (state[el] !== undefined) commit('update', [el, data[el]])
          })
          commit('update', ['username', username])
        })
        .catch(err => {
          globalError(err)
        })
    },
  },
  mutations: {
    update(state, [key, value]) {
      state[key] = value
    },
    updateField,
  },
}
